import { Controller } from "@hotwired/stimulus"

// Keeps a destructive submit button disabled until the typed confirmation
// text exactly matches the expected value (e.g. the organization's name).
// A stronger safeguard than the data-turbo-confirm dialog used elsewhere
// for destructive actions, reserved for actions severe enough to warrant
// it -- the server independently re-checks the same match, so this is a
// UX guardrail, not the real enforcement.
export default class extends Controller {
  static targets = ["input", "button"]
  static values = { match: String }

  check() {
    this.buttonTarget.disabled = this.inputTarget.value !== this.matchValue
  }
}
